import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "New Transaction", -1)
const _hoisted_2 = { class: "q-pa-md" }
const _hoisted_3 = { class: "q-gutter-x-md row justify-center" }

import { ref } from 'vue'
import { Transaction, User } from './code/api'

export default /*#__PURE__*/_defineComponent({
  __name: 'NewTransaction',
  props: { attributes: Object as () => User },
  setup(__props) {

const props = __props


const vm = ref<Transaction>({ Gems: 0, Cash: 0, BonusCash: 0 })

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    flat: "",
    bordered: "",
    class: "my-card"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator, { inset: "" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_input, {
            filled: "",
            type: "number",
            modelValue: vm.value.Gems,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.value.Gems) = $event)),
            modelModifiers: { number: true },
            label: "Gems 💎",
            "stack-label": "",
            placeholder: props.attributes?.Gems,
            "label-color": "pink"
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_q_input, {
            prefix: "$",
            filled: "",
            type: "number",
            modelValue: vm.value.Cash,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((vm.value.Cash) = $event)),
            modelModifiers: { number: true },
            label: "Cash 💵",
            "stack-label": "",
            placeholder: props.attributes?.CashCents,
            "label-color": "green"
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_q_input, {
            prefix: "$",
            filled: "",
            type: "number",
            modelValue: vm.value.BonusCash,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vm.value.BonusCash) = $event)),
            modelModifiers: { number: true },
            label: "Bonus Cash 💸",
            "stack-label": "",
            placeholder: props.attributes?.BonusCashCents,
            "label-color": "orange"
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_q_btn, {
            label: "SUBMIT",
            class: "bg-green",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('submitTransactionClicked', vm.value)))
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})